module.exports = __webpack_public_path__ + "add dental booking.png?1d4cabe082711f7c76f7b146e5ce4c55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/add dental booking.png
// module id = 349
// module chunks = 0